import React from 'react'
import Root from './components/Root'

const App = () => {
	return (
		<Root />
	)
}

export default App
